import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { objectWithIdNotFoundMessage } from "../../../Messages/errorMessages";
import { rateAgreementUrls } from "../../../URL/ApplicationUrls";
import { RateAgreement } from "../RateAgreement";
import { namedQueryKeyWithId } from "../../../ReactQuery/namedQueryKeyWithId";

export const useFetchRateAgreement = (rateAgreementId: number | string | undefined) => {
  return useQuery<RateAgreement, Error>({
    queryKey: namedQueryKeyWithId("rateAgreements", rateAgreementId),
    queryFn: () => fetchRateAgreement(rateAgreementId),
    onError: async () =>
      toast.error(objectWithIdNotFoundMessage(rateAgreementId, "Rate Agreement")),
  });
};

const fetchRateAgreement = async (id: number | string | undefined) => {
  const { data: rateAgreement } = await axios.get<RateAgreement>(
    rateAgreementUrls.apiUrlForRateAgreementWithId(id)
  );

  return rateAgreement;
};
